// @ts-nocheck

import React from 'react';
import styled, { css } from 'styled-components';

import { FreebetsIcon } from '../../../../assets/img/betting';
import Formatter from '../../../../i18n/formatter';
import { __, getCurrency } from '../../../../i18n/l10n';
import colors from '../../../../styled-components/palette';

const CONTENT_BACKGROUND_GRADIENT_TOP = '#079F1F';
const CONTENT_BACKGROUND_GRADIENT_BOTTOM = '#21C63B';
const CONTENT_BACKGROUND_COLOR = '#0A405CB3';
const WINNING_TEXT_STROKE_COLOR = '#0A2919';

const FamilyBetInfoWrapper = styled.div`
  display: inline-flex;
  position: relative;

  &::before {
    content: '';
    border-radius: 0.375em;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 0;
  }

  ${({ $isCompleted }) =>
    $isCompleted
      ? css`
          &::before {
            background-image: linear-gradient(
              to bottom,
              ${CONTENT_BACKGROUND_GRADIENT_BOTTOM} 0%,
              ${CONTENT_BACKGROUND_GRADIENT_BOTTOM} 77%
            );
          }
        `
      : null}
`;

const FamilyBetInfoContent = styled.div`
  align-items: center;
  background: ${CONTENT_BACKGROUND_COLOR};
  border-radius: 0.375em;
  color: #fff;
  display: flex;
  padding: 0 0.3em;
  position: relative;

  ${({ $isCompleted }) =>
    $isCompleted
      ? css`
          margin: 1px;
          background-image: linear-gradient(
            to bottom,
            ${CONTENT_BACKGROUND_GRADIENT_TOP} 0%,
            ${CONTENT_BACKGROUND_GRADIENT_BOTTOM} 77%
          );
        `
      : null}
`;

const Separator = styled.div`
  background: rgba(255, 255, 255, 0.8);
  height: 0.75em;
  margin: 0 0.3em;
  width: 1px;
`;

const Info = styled.div`
  align-items: baseline;
  display: flex;
`;

const InfoLabel = styled.div`
  line-height: 1.8em;
  font-size: 0.7em;
  white-space: nowrap;
`;

const InfoValue = styled.div`
  font-size: 0.875em;
  font-weight: bold;
  margin-left: 0.2em;
`;

const InfoIcon = styled.img`
  height: 0.875em;
  margin-left: 0.2em;
  width: auto;
`;

const InfoWinningLabel = styled.div`
  font-size: 0.875em;
  font-weight: bold;
  text-shadow: 0.5px 0.5px 0 ${colors.greenwinamax900};
  white-space: nowrap;
  -webkit-text-stroke: 0.5px ${WINNING_TEXT_STROKE_COLOR};
`;

type MPFamilyBetInfoProps = {
  className?: string;
  minBetOdds?: number;
  stakeMultiplicator?: number;
  wonAmount?: number;
  isCompleted?: boolean;
};

const MPFamilyInfo = ({
  className = '',
  minBetOdds = 0,
  stakeMultiplicator = 0,
  wonAmount = 0,
  isCompleted = false,
}: MPFamilyBetInfoProps) => {
  return (
    <FamilyBetInfoWrapper className={className} $isCompleted={isCompleted}>
      <FamilyBetInfoContent $isCompleted={isCompleted}>
        {isCompleted ? (
          <InfoWinningLabel>{__('Winnings %1$s', Formatter.formatNumber(wonAmount, getCurrency()))}</InfoWinningLabel>
        ) : (
          <>
            <Info>
              <InfoLabel>{__('Min. odds')}</InfoLabel>
              <InfoValue>{Formatter.formatOdd(minBetOdds)}</InfoValue>
            </Info>
            <Separator />
            <Info>
              <InfoLabel>{__('Wager')}</InfoLabel>
              <InfoValue>x{stakeMultiplicator}</InfoValue>
            </Info>
          </>
        )}
        <InfoIcon src={FreebetsIcon} />
      </FamilyBetInfoContent>
    </FamilyBetInfoWrapper>
  );
};

export default MPFamilyInfo;
